import React, { useEffect, useState } from "react";
import "./Toast.css";
import { ToastType } from "../../context/ToastContext";

interface ToastProps {
    message: string;
    type?: ToastType;
    onClose: () => void;
}

const Toast: React.FC<ToastProps> = ({ message, type = 'error', onClose }) => {
    const [visible, setVisible] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setVisible(false);
            onClose();
        }, 5000);

        return () => clearTimeout(timer);
    }, [onClose]);

    if (!visible) return null;

    const toastClass = `toast ${type === 'success' ? 'toast-success' : 'toast-error'}`;

    return (
        <div className={toastClass}>
            <span>{message}</span>
            <button className="close-btn" onClick={onClose}>×</button>
        </div>
    );
};

export default Toast;
